import { currentSite } from '../mixins/siteDetection'

const axios = require('axios')

class Api {
  static post(endpoint, params) {
    const url =
      [process.env['RAZZLE_API_URL'], process.env['RAZZLE_API_VERSION']].join(
        '/'
      ) + endpoint

    return axios.post(url, params)
  }

  static async get(endpoint, params = {}) {
    const url =
      (params.url ||
        [process.env['RAZZLE_API_URL'], process.env['RAZZLE_API_VERSION']].join(
          '/'
        )) + endpoint
    let req = params.req
    if (!req && global && global.req) {
      req = global.req
    }

    let cacheServer = null
    if (req && req.cacheServer) {
      cacheServer = req.cacheServer
    }
    delete params.req

    let caching = true
    if (process.env.NODE_ENV === 'development') {
      caching = false
    }

    const cacheKey = [endpoint, JSON.stringify(params)]
      .join('-')
      .replace(/[^A-Za-z0-9-]/g, '')
    if (cacheServer && cacheServer.get && caching) {
      try {
        const cacheData = await cacheServer.get(cacheKey)
        if (cacheData) {
          return JSON.parse(cacheData)
        }
      } catch (error) {
        // catch missing
      }
    }

    const res = await axios
      .get(url, { params: Object.assign(Api.defaultParams(), params) })
      .then(r => r.data)

    if (cacheServer && cacheServer.set && caching) {
      try {
        cacheServer.set(cacheKey, JSON.stringify(res), 60 * 5)
      } catch (error) {
        // catch missing
      }
    }

    return res
  }

  static defaultParams() {
    return {}

    /*let blacklist = localStorage.getItem('blacklist');
    blacklist = blacklist !== "" && blacklist !== undefined && blacklist !== null ? JSON.parse(blacklist) : [];

    return {
      blacklist: blacklist
    }*/
  }

  static adjustMeta(res, section, opts = {}) {
    const site = currentSite()

    const meta = res.meta || {}
    switch (section) {
      case 'doujin-show':
        meta.title = `Read ${res.data.title} online for free | ${site.siteTitle}`
        meta.description = `Read ${res.data.title} from ${res.data.series.title} with ${res.data.image_count} pages online on ${site.siteTitle} for free`
        break
      case 'parody-list':
        meta.title = `Browse over 5000 hentai Parodies online for free | ${site.siteTitle}`
        meta.description = `Browse over 5.000 hentai Parodies online on ${site.siteTitle} for free`
        break
      case 'parody-show':
        meta.title = `Browse the hentai Parody ${res.data.title} online for free | ${site.siteTitle}`
        meta.description = `Read ${res.pagination.count} Hentai Doujins from ${res.data.title} online on ${site.siteTitle} for free`
        break
      case 'tag-list':
        meta.title = `Browse all hentai ${opts.type}s online for free | ${site.siteTitle}`
        meta.description = `Check out all hentai ${opts.type}s right now on ${site.siteTitle} for free online`
        break
      case 'tag-show':
        meta.title = `Browse the hentai ${opts.type} ${res.data.title} online for free | ${site.siteTitle}`
        meta.description = `Read ${res.pagination.count} Doujins from ${res.data.title} online on ${site.siteTitle} for free`
        break
    }

    res.meta = meta
    return res
  }
}

export default Api
